import React from 'react';
import { Prices, getSelectedPrice } from '@features/price-graph';

export const useSelectedPrice = (prices: Prices, openedDate: Date) => {
	return React.useMemo(() => getSelectedPrice(prices, openedDate), [prices, openedDate]);
};
